module.exports = __webpack_public_path__ + "static/media/la-matanza.d9da0f81.svg";